import { render, staticRenderFns } from "./SettingsAppDetails.vue?vue&type=template&id=2f9ee09b&scoped=true"
import script from "./SettingsAppDetails.vue?vue&type=script&lang=js"
export * from "./SettingsAppDetails.vue?vue&type=script&lang=js"
import style0 from "./SettingsAppDetails.vue?vue&type=style&index=0&id=2f9ee09b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ee09b",
  null
  
)

export default component.exports